import type { ReactNode } from 'react';
import { api } from '@/api';
import type { Attachment } from '@/api/types';
import { formatSize } from '@/lib/format';
import { DownloadButton } from './DownloadButton';

/** An attachment is the id of a stored document: with an id it downloads, without one it is just a name. */
export function AttachmentChip({ a, icon, className, load = api.downloadDocument }: { a: Attachment; icon: ReactNode; className: string; load?: (id: string) => Promise<Blob> }) {
  return (
    <span className={className}>
      {icon}
      {a.id ? (
        <DownloadButton name={a.name} load={() => load(a.id)} className="underline decoration-strong underline-offset-2 hover:decoration-ink" label={`Скачать ${a.name}`}>
          {a.name}
        </DownloadButton>
      ) : (
        a.name
      )}
      <span className="text-faint">{formatSize(a.sizeKb)}</span>
    </span>
  );
}
